import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';
import { CommonFieldProps } from '../form.types';

export const stringToNumber = (value: string) => {
  if (value === '') return ''; // Keep empty string as it is
  if (!isNaN(Number(value))) return Number(value); // Convert valid number strings to numbers
  return ''; // Return empty string for invalid inputs
};

export type NumericFieldProps<T extends FieldValues> = CommonFieldProps<T> & {
  type: 'numeric';
};

export const NumericField = <T extends FieldValues>({
  name,
  label,
  inputProps
}: NumericFieldProps<T>) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          type="number"
          onChange={(e) => field.onChange(stringToNumber(e.target.value))}
          label={label}
          inputProps={{
            min: 1,
            ...inputProps
          }}
        />
      )}
    />
  );
};
